import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { compose } from 'recompose';
import { Button, Grid } from '@material-ui/core';
import { withRouter, RouteComponentProps } from 'react-router';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { Loaders } from 'components';

interface IProps {
  working: boolean;
}

interface IPropsEnhanced extends IProps, RouteComponentProps, WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    container: {
      paddingTop: theme.spacing(6),
    },
    button: {
      minWidth: 140,
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(withRouter, withStyles(styles));

const PeopleInvite: FC<IPropsEnhanced> = ({ classes, history, working }) => {
  return (
    <Grid container spacing={2} className={classes.container} justify="flex-end">
      <Grid item>
        <Button size="large" className={classes.button} onClick={() => history.goBack()}>
          <Trans i18nKey="common:cancel" />
        </Button>
      </Grid>
      <Grid item>
        {working ? (
          <Loaders.Standard height={38} />
        ) : (
          <Button
            size="large"
            className={classes.button}
            disabled={working}
            type="submit"
            variant="contained"
            color="primary">
            <Trans i18nKey="common:send" />
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default enhancers(PeopleInvite);
